var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "thread-viewer" } },
    [
      _c("div", { staticClass: "toolbar" }, [
        _c("div", { staticClass: "left" }),
        _vm._v(" "),
        _c("div", { staticClass: "actions" }, [
          _c(
            "button",
            {
              staticClass: "reply",
              on: {
                click: function ($event) {
                  return _vm.replyToAll(true)
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "material-icons",
                  staticStyle: {
                    "font-size": "20px",
                    "margin-left": "5px",
                    color: "white",
                  },
                },
                [_vm._v("reply")]
              ),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("mail.reply")) +
                  "\n            "
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      !!_vm.mailDetailsClone && _vm.mailDetailsClone.length > 0
        ? _c(
            "div",
            { staticClass: "thread" },
            [
              _c("div", { staticClass: "thread-header" }, [
                _c("div", { staticClass: "subject" }, [
                  _vm._v(
                    _vm._s(
                      _vm.mailDetailsClone[_vm.mailDetailsClone.length - 1]
                        .subject
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "actions" }, [
                  _c(
                    "div",
                    { staticClass: "muiButtonGroup" },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "material-icons header-reply",
                          staticStyle: { "font-size": "22px" },
                          on: {
                            click: function ($event) {
                              return _vm.replyToAll(true)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                        reply\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-popover",
                        {
                          attrs: {
                            id: "mail-multi-btn",
                            placement: "bottom",
                            trigger: "click",
                          },
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "material-icons header-more",
                              staticStyle: { "font-size": "22px" },
                            },
                            [_vm._v("more_vert")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "mail-detail",
                                  on: {
                                    click: function ($event) {
                                      return _vm.reply(true)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "material-icons" },
                                    [_vm._v("reply")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "mail-detail-item" },
                                    [_vm._v(_vm._s(_vm.$t("mail.reply")))]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "mail-detail",
                                  on: {
                                    click: function ($event) {
                                      return _vm.replyToAll(true)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "material-icons" },
                                    [_vm._v("reply_all")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "mail-detail-item" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("mail.replyAll")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "mail-detail",
                                  on: {
                                    click: function ($event) {
                                      return _vm.forwardMail(true)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "material-icons" },
                                    [_vm._v("forward")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "mail-detail-item" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("mail.forward")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "mail-detail",
                                  on: {
                                    click: function () {
                                      return (_vm.deleteThreadVisible = true)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "material-icons" },
                                    [_vm._v("delete")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "mail-detail-item" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("mail.deleteThread")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm.replyMessageVisible &&
              (_vm.composerView || _vm.isVisibleComposer)
                ? _c("MailComposer", {
                    attrs: {
                      replyContent: _vm.replyContent,
                      isForward: _vm.isForward,
                      selectedMailItem: _vm.mailDetailsClone[0],
                      isUserMailDetail: _vm.isUserMailDetail,
                      mailDetails: _vm.mailDetails,
                      mailDetailPage: _vm.mailDetailPage,
                    },
                    on: {
                      closeEditor: function ($event) {
                        _vm.replyMessageVisible = false
                      },
                      newMailDetail: function (e) {
                        return (_vm.newMailDetail = e)
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.mailDetailsClone, function (mail, i) {
                return _c(
                  "div",
                  [
                    _c("div", { staticClass: "tv-content" }, [
                      _c("div", { staticClass: "tv-header" }, [
                        _c("div", { staticClass: "avatar" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "tv-metas" }, [
                          _c("div", { staticClass: "left" }, [
                            _c("div", [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("mail.From") + ": ")),
                              ]),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticStyle: { "font-weight": "700" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.getMailAddress(mail.sender))
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            !mail.incoming
                              ? _c("span", { staticClass: "name" }, [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("mail.FromName" + "") + ": "
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticStyle: { "font-weight": "700" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.getFromMailAddress(mail))
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "to-list" },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.$t("mail.To")) +
                                    ":\n                                "
                                ),
                                _vm._l(mail.to_list, function (to) {
                                  return _c(
                                    "span",
                                    { staticClass: "ml-2 to-list-single" },
                                    [
                                      _c(
                                        "a-tooltip",
                                        { attrs: { title: to } },
                                        [
                                          _c("span", { staticClass: "name" }, [
                                            _vm._v(
                                              _vm._s(_vm.getMailAddress(to))
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                }),
                              ],
                              2
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "right" },
                            [
                              _c("span", [_vm._v(_vm._s(_vm.getTime(mail)))]),
                              _vm._v(" "),
                              _c(
                                "a-popover",
                                {
                                  attrs: {
                                    id: "mail-multi-btn",
                                    placement: "bottom",
                                    trigger: "click",
                                  },
                                },
                                [
                                  _c("md-icon", [_vm._v("more_vert")]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "mail-detail",
                                          on: {
                                            click: function ($event) {
                                              return _vm.reply(false, mail, i)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "material-icons" },
                                            [_vm._v("reply")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "mail-detail-item" },
                                            [_vm._v("Reply")]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "mail-detail",
                                          on: {
                                            click: function ($event) {
                                              return _vm.replyToAll(mail, i)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "material-icons" },
                                            [_vm._v("reply_all")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "mail-detail-item" },
                                            [_vm._v(" Reply to all ")]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "mail-detail",
                                          on: {
                                            click: function ($event) {
                                              return _vm.forwardMail(
                                                false,
                                                mail,
                                                i
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "material-icons" },
                                            [_vm._v("forward")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "mail-detail-item" },
                                            [_vm._v(" Forward ")]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "mail-detail",
                                          on: {
                                            click: function ($event) {
                                              return _vm.setDeleteThreadMessage(
                                                mail
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "material-icons" },
                                            [_vm._v("delete")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "mail-detail-item" },
                                            [_vm._v(" Delete thread message ")]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "message-content",
                        domProps: {
                          innerHTML: _vm._s(_vm.getMailContent(mail)),
                        },
                      }),
                      _vm._v(" "),
                      _c("hr", { staticClass: "hr-divider" }),
                      _vm._v(" "),
                      !!mail.attachments && mail.attachments.length > 0
                        ? _c("div", { staticClass: "attachments-wrapper" }, [
                            _c("span", { staticClass: "title" }, [
                              _vm._v(_vm._s(_vm.$t("mail.attachments"))),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              _vm._l(mail.attachments, function (attachment) {
                                return _c(
                                  "div",
                                  { staticClass: "attachments" },
                                  [
                                    attachment.type === "image"
                                      ? _c("ImageMessage", {
                                          attrs: { message: attachment },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    attachment.type === "asset"
                                      ? _c("AssetMessage", {
                                          attrs: {
                                            message: attachment,
                                            "extended-style":
                                              _vm.extendedStyle(),
                                            "message-colors":
                                              _vm.receivedColorsStyle(),
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              }),
                              0
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    !!mail.reply && (_vm.composerView || _vm.isVisibleComposer)
                      ? _c("MailComposer", {
                          attrs: {
                            selectedMailItem: mail,
                            replyContent: _vm.replyContent,
                            isForward: _vm.isForward,
                            isUserMailDetail: _vm.isUserMailDetail,
                            mailDetails: _vm.mailDetails,
                            mailDetailPage: _vm.mailDetailPage,
                          },
                          on: {
                            closeEditor: function ($event) {
                              return _vm.replyFalse(mail, i)
                            },
                            newMailDetail: function (e) {
                              return (_vm.newMailDetail = e)
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.deleteThreadMessageVisible
        ? _c(
            "a-modal",
            {
              attrs: {
                id: "delete-user-modal",
                title: "Maili Sil",
                centered: "",
              },
              on: { ok: _vm.deleteThreadMessage },
              model: {
                value: _vm.deleteThreadMessageVisible,
                callback: function ($$v) {
                  _vm.deleteThreadMessageVisible = $$v
                },
                expression: "deleteThreadMessageVisible",
              },
            },
            [
              _c("div", { staticClass: "delete-user-modal-message" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("message.deleteMail")) +
                    "\n        "
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.deleteThreadVisible
        ? _c(
            "a-modal",
            {
              attrs: {
                id: "delete-user-modal",
                title: "Tüm Mailleri Sil",
                centered: "",
              },
              on: { ok: _vm.deleteThread },
              model: {
                value: _vm.deleteThreadVisible,
                callback: function ($$v) {
                  _vm.deleteThreadVisible = $$v
                },
                expression: "deleteThreadVisible",
              },
            },
            [
              _c("div", { staticClass: "delete-user-modal-message" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("message.deleteThread")) +
                    "\n        "
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }